export type TransactionAmountPresentation = 'default' | 'corporate';

/** Сумма для отображения: в корпоративном режиме знак инвертируется (как расход компании). */
export function getDisplayAmount(
  amount: number,
  presentation: TransactionAmountPresentation = 'default'
): number {
  return presentation === 'corporate' ? -amount : amount;
}

export function formatTransactionAmount(
  amount: number,
  presentation: TransactionAmountPresentation = 'default'
): string {
  const v = getDisplayAmount(amount, presentation);
  return v < 0
    ? `${Number(v).toFixed(2)}\u00A0€`
    : `+${Number(v).toFixed(2)}\u00A0€`;
}
